import React from 'react'

import { Icon, Loader } from '@fourthwall/components'
import type { DnsRecord } from '@fourthwall/services/dist/DnsApiClient'

import { DnsRecordInfoCell } from '../DnsRecordInfoCell/DnsRecordInfoCell'
import * as S from './DnsRecordStatusCell.styled'

export interface DnsRecordStatusCellProps {
  record: DnsRecord
  isVerificationInProgress: boolean
}

export const DnsRecordStatusCell = ({
  record,
  isVerificationInProgress,
}: DnsRecordStatusCellProps) => {
  const getStatusContent = () => {
    if (isVerificationInProgress) {
      return (
        <S.LoaderWrapper>
          <Loader size="small" />
        </S.LoaderWrapper>
      )
    }

    if (record.status === 'VALID') {
      return <Icon component={S.StatusTickIcon} height={24} width={24} />
    }

    if (record.status === 'INVALID') {
      return <Icon component={S.StatusCloseIcon} height={24} width={24} />
    }

    return null
  }

  const statusContent = getStatusContent()

  return (
    <S.Container>
      <S.Info>
        <DnsRecordInfoCell record={record} />
      </S.Info>
      {statusContent ? <S.StatusWrapper>{statusContent}</S.StatusWrapper> : null}
    </S.Container>
  )
}
